import { styled } from "@mui/material/styles";

const StyledTermsCondition = styled("div")(
  ({ theme }) => `
  .terms-condition-wrap {
    padding: 30px 90px 200px;
    @media screen and (max-width: 1024px) {
    padding: 30px 50px 200px;
  }
    @media screen and (max-width: 480px) {
      padding: 30px 23px 200px;
    
    }
  }
.no-content {
  font-family: Lexend;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.palette.customColor.secondarySecond};
  margin: 20px auto;
}    
`
);

export default StyledTermsCondition;
